import Immutable from 'immutable';

import list from '../data/variables';
import uniqueVariables from '../data/uniqueVariables';
import includes from 'lodash/includes';
import VariableRole from '../data/VariableRole';

import { ScenarioConfiguration } from '../Scenario';
import { BusinessPlan } from '../BusinessPlan';
import { Variable } from '../Variable';

export const resetBusinessPlans = (scenarioConfig: ScenarioConfiguration) => {
  const { params } = list;
  let businessPlans = Immutable.Map<number,BusinessPlan>();
  for (let i = 1; i <= 3; i++) {
    const businessPlan = new BusinessPlan(i);
    for (let variable of scenarioConfig.variables) {
      if (includes(uniqueVariables, variable.id)) {
        businessPlan.addVariable(new Variable(
          businessPlan.submission,
          variable.id,
          0,
          variable.initialValue,
          `${variable.id}:0`,
          false,
          variable.showInGui
        ))
      } else {
        for (let year = 1; year < 4; year++) {
          let value;
          switch (variable.role) {
            case VariableRole.PARAM:
              const paramsMap = Immutable.Map(params);
              value = paramsMap.get(`${variable.id}:${year}`);
              break;
          }
          value = value || variable.initialValue;
          businessPlan.addVariable(new Variable(
            businessPlan.submission,
            variable.id,
            year,
            value,
            `${variable.id}:${year}`,
            false,
            variable.showInGui
          ));
        }
      }
    }
    businessPlans = businessPlans.set(businessPlan.submission, businessPlan);
  }


  return businessPlans;
}